
export default {
  head() {
    return {
      title: "Math Worksheets | Math Worksheets Online | BrainGymJr",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Learning maths can be made fun and easy by giving the children maths worksheets with puzzles and games based on maths. This will help them to perfect their math skills."
        }
      ]
    };
  },
  layout(context) {
    return context.$auth.loggedIn ? "parents" : "home";
  },
  name: "math-worksheet"
};
